import { fromClass, fromClassArray } from "fw-model";
import { SearchResult } from "./search-result";
import { SelectionItem } from "./definitions";

export enum WorkflowRunStatus {
    NotRun = 0,
    Waiting = 1,
    Complete = 2,
    Aborted = 3,
    Error = 4
}

export type Filter = {
    organization?: string;
    status?: number;
    workflowId?: string;
    range?: string | [];
    missing?: string;
};

export type HeadersType = {
    label: string;
    sort?: string;
    key?: string;
    class?: string;
};

export type SortParamsType = {
    column: string;
    order: "asc" | "desc";
};

export type Flag = {
    open: boolean;
};

export type TabsType = {
    label: string;
    value: number;
};

export class AtsWorkflowTaskSearchResult extends SearchResult<AtsWorkflowRunInfo> {}

export class AtsWorkflowRunMetaData {
    ObjectType: string;
    ObjectId: string;
    ApplicationId: string;
    DateCreatedUtc: Date;
    DateUpdatedUtc: Date;
    OrganizationId: string;
    SeasonId: string;
    WaitingNodeId: string;
    WaitingOnTaskId: string;
    ResumeUtc: Date;
    Status: WorkflowRunStatus;
    ErrorMessage: string;
}

export class AtsWorkflowNodeRun {
    NodeId: string;
    DecisionKey: string;
    StartedUtc: Date;
    CompletedUtc: Date;
}

export class AtsWorkflowNode {
    Id: string;
    Type: string;
}

export class AtsWorkflowTrigger {
    Id: string;
    Type: string;
}

export class AtsWorkflow {
    Id: string;
    Name: string;
    Active: boolean;
    IsDeleted: boolean;
    @fromClass Path: AtsWorkflowNode[];
}

export class AtsWorkflowRun {
    Id: string;
    @fromClass Trigger: AtsWorkflowTrigger;
    @fromClass Workflow: AtsWorkflow;
    @fromClass MetaData: AtsWorkflowRunMetaData;
    @fromClassArray(AtsWorkflowNodeRun) Run: AtsWorkflowNodeRun[];
}

export class AtsWorkflowRunInfo {
    @fromClass Run: AtsWorkflowRun;
    OrganizationId: string;
    OrganizationName: string;
    WorkflowId: string;
    WorkflowName: string;
}

export const WORKFLOW_STATUSES: SelectionItem[] = [
    { label: "All Statuses", value: null },
    { label: "Not Run", value: WorkflowRunStatus.NotRun, color: "pending-color", hexColor: "#fde68a" },
    { label: "Waiting", value: WorkflowRunStatus.Waiting, color: "pending-color", hexColor: "#fde68a" },
    { label: "Complete", value: WorkflowRunStatus.Complete, color: "complete-color", hexColor: "#a7f3d0" },
    { label: "Aborted", value: WorkflowRunStatus.Aborted, color: "error-color", hexColor: "#fecaca" },
    { label: "Error", value: WorkflowRunStatus.Error, color: "error-color", hexColor: "#fecaca", styleColor: "#7f1d1d" }
];

export function getStatusName(index): string {
    return WORKFLOW_STATUSES.find((item) => item.value === index)?.label;
}

export function getStatusColor(index): string {
    return WORKFLOW_STATUSES.find((item) => item.value === index)?.color ?? "pending-color";
}
